import { Component, OnInit } from '@angular/core';
import { EventService } from '../../event.service';
import {Message} from '../../models/message';
import {Severity} from '../..';


@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

    constructor(
        public eventService: EventService
    ) { }

    ngOnInit() {
    }

    getSeverity(message: Message): string {
        if (!message.severity) {
            message.severity = Severity.INFO;
        }
        return 'alert-' + message.severity;
    }
}
